/**
 * Song Data for Auto-Play Feature
 * Format: { note, octave, duration (ms), delay (ms from start) }
 * All songs are copyright-free / public domain
 */

export const SONGS = {
  // Jingle Bells (Public Domain) - Full Version
  jingleBells: {
    title: 'ジングルベル',
    titleEn: 'Jingle Bells',
    recommendedDrum: '8ビート',
    recommendedDrumKey: 'rock_8beat',
    bpm: 120,
    tempo: 120,
    notes: [
      // Verse 1 - "Jingle bells, jingle bells, jingle all the way"
      { note: 'E', octave: 4, duration: 200, delay: 0 },
      { note: 'E', octave: 4, duration: 200, delay: 200 },
      { note: 'E', octave: 4, duration: 400, delay: 400 },
      { note: 'E', octave: 4, duration: 200, delay: 800 },
      { note: 'E', octave: 4, duration: 200, delay: 1000 },
      { note: 'E', octave: 4, duration: 400, delay: 1200 },
      { note: 'E', octave: 4, duration: 200, delay: 1600 },
      { note: 'G', octave: 4, duration: 200, delay: 1800 },
      { note: 'C', octave: 4, duration: 300, delay: 2000 },
      { note: 'D', octave: 4, duration: 100, delay: 2300 },
      { note: 'E', octave: 4, duration: 600, delay: 2400 },

      // "Oh what fun it is to ride in a one-horse open sleigh"
      { note: 'F', octave: 4, duration: 200, delay: 3000 },
      { note: 'F', octave: 4, duration: 200, delay: 3200 },
      { note: 'F', octave: 4, duration: 300, delay: 3400 },
      { note: 'F', octave: 4, duration: 100, delay: 3700 },
      { note: 'F', octave: 4, duration: 200, delay: 3800 },
      { note: 'E', octave: 4, duration: 200, delay: 4000 },
      { note: 'E', octave: 4, duration: 200, delay: 4200 },
      { note: 'E', octave: 4, duration: 100, delay: 4400 },
      { note: 'E', octave: 4, duration: 100, delay: 4500 },
      { note: 'E', octave: 4, duration: 200, delay: 4600 },
      { note: 'D', octave: 4, duration: 200, delay: 4800 },
      { note: 'D', octave: 4, duration: 200, delay: 5000 },
      { note: 'E', octave: 4, duration: 200, delay: 5200 },
      { note: 'D', octave: 4, duration: 400, delay: 5400 },
      { note: 'G', octave: 4, duration: 400, delay: 5800 },

      // Repeat Verse 1
      { note: 'E', octave: 4, duration: 200, delay: 6200 },
      { note: 'E', octave: 4, duration: 200, delay: 6400 },
      { note: 'E', octave: 4, duration: 400, delay: 6600 },
      { note: 'E', octave: 4, duration: 200, delay: 7000 },
      { note: 'E', octave: 4, duration: 200, delay: 7200 },
      { note: 'E', octave: 4, duration: 400, delay: 7400 },
      { note: 'E', octave: 4, duration: 200, delay: 7800 },
      { note: 'G', octave: 4, duration: 200, delay: 8000 },
      { note: 'C', octave: 4, duration: 300, delay: 8200 },
      { note: 'D', octave: 4, duration: 100, delay: 8500 },
      { note: 'E', octave: 4, duration: 600, delay: 8600 },

      { note: 'F', octave: 4, duration: 200, delay: 9200 },
      { note: 'F', octave: 4, duration: 200, delay: 9400 },
      { note: 'F', octave: 4, duration: 200, delay: 9600 },
      { note: 'F', octave: 4, duration: 200, delay: 9800 },
      { note: 'F', octave: 4, duration: 200, delay: 10000 },
      { note: 'E', octave: 4, duration: 200, delay: 10200 },
      { note: 'E', octave: 4, duration: 200, delay: 10400 },
      { note: 'E', octave: 4, duration: 100, delay: 10600 },
      { note: 'E', octave: 4, duration: 100, delay: 10700 },
      { note: 'G', octave: 4, duration: 200, delay: 10800 },
      { note: 'G', octave: 4, duration: 200, delay: 11000 },
      { note: 'F', octave: 4, duration: 200, delay: 11200 },
      { note: 'D', octave: 4, duration: 200, delay: 11400 },
      { note: 'C', octave: 4, duration: 800, delay: 11600 },

      // Chorus - "Dashing through the snow"
      { note: 'G', octave: 3, duration: 200, delay: 12400 },
      { note: 'E', octave: 4, duration: 200, delay: 12600 },
      { note: 'D', octave: 4, duration: 200, delay: 12800 },
      { note: 'C', octave: 4, duration: 200, delay: 13000 },
      { note: 'G', octave: 3, duration: 600, delay: 13200 },
      { note: 'G', octave: 3, duration: 100, delay: 13800 },
      { note: 'G', octave: 3, duration: 100, delay: 13900 },
      { note: 'E', octave: 4, duration: 200, delay: 14000 },
      { note: 'D', octave: 4, duration: 200, delay: 14200 },
      { note: 'C', octave: 4, duration: 200, delay: 14400 },
      { note: 'A', octave: 3, duration: 800, delay: 14600 },

      { note: 'A', octave: 3, duration: 200, delay: 15400 },
      { note: 'F', octave: 4, duration: 200, delay: 15600 },
      { note: 'E', octave: 4, duration: 200, delay: 15800 },
      { note: 'D', octave: 4, duration: 200, delay: 16000 },
      { note: 'B', octave: 3, duration: 800, delay: 16200 },
      { note: 'G', octave: 4, duration: 200, delay: 17000 },
      { note: 'G', octave: 4, duration: 200, delay: 17200 },
      { note: 'F', octave: 4, duration: 200, delay: 17400 },
      { note: 'D', octave: 4, duration: 200, delay: 17600 },
      { note: 'E', octave: 4, duration: 800, delay: 17800 },

      // Back to main theme
      { note: 'G', octave: 3, duration: 200, delay: 18600 },
      { note: 'E', octave: 4, duration: 200, delay: 18800 },
      { note: 'D', octave: 4, duration: 200, delay: 19000 },
      { note: 'C', octave: 4, duration: 200, delay: 19200 },
      { note: 'G', octave: 3, duration: 600, delay: 19400 },
      { note: 'G', octave: 3, duration: 100, delay: 20000 },
      { note: 'G', octave: 3, duration: 100, delay: 20100 },
      { note: 'E', octave: 4, duration: 200, delay: 20200 },
      { note: 'D', octave: 4, duration: 200, delay: 20400 },
      { note: 'C', octave: 4, duration: 200, delay: 20600 },
      { note: 'A', octave: 3, duration: 800, delay: 20800 },

      { note: 'A', octave: 3, duration: 200, delay: 21600 },
      { note: 'F', octave: 4, duration: 200, delay: 21800 },
      { note: 'E', octave: 4, duration: 200, delay: 22000 },
      { note: 'D', octave: 4, duration: 200, delay: 22200 },
      { note: 'G', octave: 4, duration: 200, delay: 22400 },
      { note: 'G', octave: 4, duration: 200, delay: 22600 },
      { note: 'G', octave: 4, duration: 200, delay: 22800 },
      { note: 'G', octave: 4, duration: 200, delay: 23000 },
      { note: 'A', octave: 4, duration: 200, delay: 23200 },
      { note: 'G', octave: 4, duration: 200, delay: 23400 },
      { note: 'F', octave: 4, duration: 200, delay: 23600 },
      { note: 'D', octave: 4, duration: 200, delay: 23800 },
      { note: 'C', octave: 4, duration: 1200, delay: 24000 },
    ],
  },

  // Silent Night (Public Domain) - Full Version
  silentNight: {
    title: 'きよしこの夜',
    titleEn: 'Silent Night',
    recommendedDrum: 'バラード',
    recommendedDrumKey: 'ballad',
    bpm: 80,
    tempo: 80,
    notes: [
      // Verse 1
      { note: 'G', octave: 4, duration: 600, delay: 0 },
      { note: 'A', octave: 4, duration: 200, delay: 600 },
      { note: 'G', octave: 4, duration: 400, delay: 800 },
      { note: 'E', octave: 4, duration: 1200, delay: 1200 },

      { note: 'G', octave: 4, duration: 600, delay: 2400 },
      { note: 'A', octave: 4, duration: 200, delay: 3000 },
      { note: 'G', octave: 4, duration: 400, delay: 3200 },
      { note: 'E', octave: 4, duration: 1200, delay: 3600 },

      { note: 'D', octave: 5, duration: 800, delay: 4800 },
      { note: 'D', octave: 5, duration: 400, delay: 5600 },
      { note: 'B', octave: 4, duration: 1200, delay: 6000 },

      { note: 'C', octave: 5, duration: 800, delay: 7200 },
      { note: 'C', octave: 5, duration: 400, delay: 8000 },
      { note: 'G', octave: 4, duration: 1200, delay: 8400 },

      { note: 'A', octave: 4, duration: 800, delay: 9600 },
      { note: 'A', octave: 4, duration: 400, delay: 10400 },
      { note: 'C', octave: 5, duration: 600, delay: 10800 },
      { note: 'B', octave: 4, duration: 200, delay: 11400 },
      { note: 'A', octave: 4, duration: 400, delay: 11600 },
      { note: 'G', octave: 4, duration: 600, delay: 12000 },
      { note: 'A', octave: 4, duration: 200, delay: 12600 },
      { note: 'G', octave: 4, duration: 400, delay: 12800 },
      { note: 'E', octave: 4, duration: 1200, delay: 13200 },

      { note: 'A', octave: 4, duration: 800, delay: 14400 },
      { note: 'A', octave: 4, duration: 400, delay: 15200 },
      { note: 'C', octave: 5, duration: 600, delay: 15600 },
      { note: 'B', octave: 4, duration: 200, delay: 16200 },
      { note: 'A', octave: 4, duration: 400, delay: 16400 },
      { note: 'G', octave: 4, duration: 600, delay: 16800 },
      { note: 'A', octave: 4, duration: 200, delay: 17400 },
      { note: 'G', octave: 4, duration: 400, delay: 17600 },
      { note: 'E', octave: 4, duration: 1200, delay: 18000 },

      // Verse 2
      { note: 'D', octave: 5, duration: 800, delay: 19200 },
      { note: 'D', octave: 5, duration: 400, delay: 20000 },
      { note: 'F', octave: 5, duration: 600, delay: 20400 },
      { note: 'D', octave: 5, duration: 200, delay: 21000 },
      { note: 'B', octave: 4, duration: 400, delay: 21200 },
      { note: 'C', octave: 5, duration: 1200, delay: 21600 },
      { note: 'E', octave: 5, duration: 1200, delay: 22800 },

      { note: 'C', octave: 5, duration: 400, delay: 24000 },
      { note: 'G', octave: 4, duration: 200, delay: 24400 },
      { note: 'E', octave: 4, duration: 200, delay: 24600 },
      { note: 'G', octave: 4, duration: 600, delay: 24800 },
      { note: 'F', octave: 4, duration: 200, delay: 25400 },
      { note: 'D', octave: 4, duration: 400, delay: 25600 },
      { note: 'C', octave: 4, duration: 1800, delay: 26000 },
    ],
  },

  // Ode to Joy (Beethoven - Public Domain) - Full Version
  odeToJoy: {
    title: '歓喜の歌',
    titleEn: 'Ode to Joy',
    recommendedDrum: '8ビート',
    recommendedDrumKey: 'rock_8beat',
    bpm: 110,
    tempo: 110,
    notes: [
      // Main theme
      { note: 'E', octave: 4, duration: 300, delay: 0 },
      { note: 'E', octave: 4, duration: 300, delay: 300 },
      { note: 'F', octave: 4, duration: 300, delay: 600 },
      { note: 'G', octave: 4, duration: 300, delay: 900 },
      { note: 'G', octave: 4, duration: 300, delay: 1200 },
      { note: 'F', octave: 4, duration: 300, delay: 1500 },
      { note: 'E', octave: 4, duration: 300, delay: 1800 },
      { note: 'D', octave: 4, duration: 300, delay: 2100 },
      { note: 'C', octave: 4, duration: 300, delay: 2400 },
      { note: 'C', octave: 4, duration: 300, delay: 2700 },
      { note: 'D', octave: 4, duration: 300, delay: 3000 },
      { note: 'E', octave: 4, duration: 300, delay: 3300 },
      { note: 'E', octave: 4, duration: 450, delay: 3600 },
      { note: 'D', octave: 4, duration: 150, delay: 4050 },
      { note: 'D', octave: 4, duration: 600, delay: 4200 },

      // Repeat main theme
      { note: 'E', octave: 4, duration: 300, delay: 4800 },
      { note: 'E', octave: 4, duration: 300, delay: 5100 },
      { note: 'F', octave: 4, duration: 300, delay: 5400 },
      { note: 'G', octave: 4, duration: 300, delay: 5700 },
      { note: 'G', octave: 4, duration: 300, delay: 6000 },
      { note: 'F', octave: 4, duration: 300, delay: 6300 },
      { note: 'E', octave: 4, duration: 300, delay: 6600 },
      { note: 'D', octave: 4, duration: 300, delay: 6900 },
      { note: 'C', octave: 4, duration: 300, delay: 7200 },
      { note: 'C', octave: 4, duration: 300, delay: 7500 },
      { note: 'D', octave: 4, duration: 300, delay: 7800 },
      { note: 'E', octave: 4, duration: 300, delay: 8100 },
      { note: 'D', octave: 4, duration: 450, delay: 8400 },
      { note: 'C', octave: 4, duration: 150, delay: 8850 },
      { note: 'C', octave: 4, duration: 600, delay: 9000 },

      // Middle section
      { note: 'D', octave: 4, duration: 300, delay: 9600 },
      { note: 'D', octave: 4, duration: 300, delay: 9900 },
      { note: 'E', octave: 4, duration: 300, delay: 10200 },
      { note: 'C', octave: 4, duration: 300, delay: 10500 },
      { note: 'D', octave: 4, duration: 300, delay: 10800 },
      { note: 'E', octave: 4, duration: 150, delay: 11100 },
      { note: 'F', octave: 4, duration: 150, delay: 11250 },
      { note: 'E', octave: 4, duration: 300, delay: 11400 },
      { note: 'C', octave: 4, duration: 300, delay: 11700 },
      { note: 'D', octave: 4, duration: 300, delay: 12000 },
      { note: 'E', octave: 4, duration: 150, delay: 12300 },
      { note: 'F', octave: 4, duration: 150, delay: 12450 },
      { note: 'E', octave: 4, duration: 300, delay: 12600 },
      { note: 'D', octave: 4, duration: 300, delay: 12900 },
      { note: 'C', octave: 4, duration: 300, delay: 13200 },
      { note: 'D', octave: 4, duration: 300, delay: 13500 },
      { note: 'G', octave: 3, duration: 600, delay: 13800 },

      // Final section (main theme variation)
      { note: 'E', octave: 4, duration: 300, delay: 14400 },
      { note: 'E', octave: 4, duration: 300, delay: 14700 },
      { note: 'F', octave: 4, duration: 300, delay: 15000 },
      { note: 'G', octave: 4, duration: 300, delay: 15300 },
      { note: 'G', octave: 4, duration: 300, delay: 15600 },
      { note: 'F', octave: 4, duration: 300, delay: 15900 },
      { note: 'E', octave: 4, duration: 300, delay: 16200 },
      { note: 'D', octave: 4, duration: 300, delay: 16500 },
      { note: 'C', octave: 4, duration: 300, delay: 16800 },
      { note: 'C', octave: 4, duration: 300, delay: 17100 },
      { note: 'D', octave: 4, duration: 300, delay: 17400 },
      { note: 'E', octave: 4, duration: 300, delay: 17700 },
      { note: 'D', octave: 4, duration: 450, delay: 18000 },
      { note: 'C', octave: 4, duration: 150, delay: 18450 },
      { note: 'C', octave: 4, duration: 900, delay: 18600 },
    ],
  },

  // Twinkle Twinkle Little Star (Public Domain) - Full Version
  twinkleTwinkle: {
    title: 'きらきら星',
    titleEn: 'Twinkle Twinkle',
    recommendedDrum: 'ポップ',
    recommendedDrumKey: 'pop',
    bpm: 90,
    tempo: 90,
    notes: [
      // First verse
      { note: 'C', octave: 4, duration: 400, delay: 0 },
      { note: 'C', octave: 4, duration: 400, delay: 400 },
      { note: 'G', octave: 4, duration: 400, delay: 800 },
      { note: 'G', octave: 4, duration: 400, delay: 1200 },
      { note: 'A', octave: 4, duration: 400, delay: 1600 },
      { note: 'A', octave: 4, duration: 400, delay: 2000 },
      { note: 'G', octave: 4, duration: 800, delay: 2400 },

      { note: 'F', octave: 4, duration: 400, delay: 3200 },
      { note: 'F', octave: 4, duration: 400, delay: 3600 },
      { note: 'E', octave: 4, duration: 400, delay: 4000 },
      { note: 'E', octave: 4, duration: 400, delay: 4400 },
      { note: 'D', octave: 4, duration: 400, delay: 4800 },
      { note: 'D', octave: 4, duration: 400, delay: 5200 },
      { note: 'C', octave: 4, duration: 800, delay: 5600 },

      // Middle section
      { note: 'G', octave: 4, duration: 400, delay: 6400 },
      { note: 'G', octave: 4, duration: 400, delay: 6800 },
      { note: 'F', octave: 4, duration: 400, delay: 7200 },
      { note: 'F', octave: 4, duration: 400, delay: 7600 },
      { note: 'E', octave: 4, duration: 400, delay: 8000 },
      { note: 'E', octave: 4, duration: 400, delay: 8400 },
      { note: 'D', octave: 4, duration: 800, delay: 8800 },

      { note: 'G', octave: 4, duration: 400, delay: 9600 },
      { note: 'G', octave: 4, duration: 400, delay: 10000 },
      { note: 'F', octave: 4, duration: 400, delay: 10400 },
      { note: 'F', octave: 4, duration: 400, delay: 10800 },
      { note: 'E', octave: 4, duration: 400, delay: 11200 },
      { note: 'E', octave: 4, duration: 400, delay: 11600 },
      { note: 'D', octave: 4, duration: 800, delay: 12000 },

      // Repeat first verse
      { note: 'C', octave: 4, duration: 400, delay: 12800 },
      { note: 'C', octave: 4, duration: 400, delay: 13200 },
      { note: 'G', octave: 4, duration: 400, delay: 13600 },
      { note: 'G', octave: 4, duration: 400, delay: 14000 },
      { note: 'A', octave: 4, duration: 400, delay: 14400 },
      { note: 'A', octave: 4, duration: 400, delay: 14800 },
      { note: 'G', octave: 4, duration: 800, delay: 15200 },

      { note: 'F', octave: 4, duration: 400, delay: 16000 },
      { note: 'F', octave: 4, duration: 400, delay: 16400 },
      { note: 'E', octave: 4, duration: 400, delay: 16800 },
      { note: 'E', octave: 4, duration: 400, delay: 17200 },
      { note: 'D', octave: 4, duration: 400, delay: 17600 },
      { note: 'D', octave: 4, duration: 400, delay: 18000 },
      { note: 'C', octave: 4, duration: 1200, delay: 18400 },
    ],
  },

  // Canon in D (Pachelbel - Public Domain)
  canonInD: {
    title: 'カノン',
    titleEn: 'Canon in D',
    recommendedDrum: 'バラード',
    recommendedDrumKey: 'ballad',
    bpm: 85,
    tempo: 85,
    notes: [
      // Main theme
      { note: 'F#', octave: 5, duration: 500, delay: 0 },
      { note: 'E', octave: 5, duration: 500, delay: 500 },
      { note: 'D', octave: 5, duration: 500, delay: 1000 },
      { note: 'C#', octave: 5, duration: 500, delay: 1500 },
      { note: 'B', octave: 4, duration: 500, delay: 2000 },
      { note: 'A', octave: 4, duration: 500, delay: 2500 },
      { note: 'B', octave: 4, duration: 500, delay: 3000 },
      { note: 'C#', octave: 5, duration: 500, delay: 3500 },

      { note: 'D', octave: 5, duration: 500, delay: 4000 },
      { note: 'C#', octave: 5, duration: 500, delay: 4500 },
      { note: 'B', octave: 4, duration: 500, delay: 5000 },
      { note: 'A', octave: 4, duration: 500, delay: 5500 },
      { note: 'G', octave: 4, duration: 500, delay: 6000 },
      { note: 'F#', octave: 4, duration: 500, delay: 6500 },
      { note: 'G', octave: 4, duration: 500, delay: 7000 },
      { note: 'A', octave: 4, duration: 500, delay: 7500 },

      // Variation 1
      { note: 'F#', octave: 4, duration: 250, delay: 8000 },
      { note: 'G', octave: 4, duration: 250, delay: 8250 },
      { note: 'A', octave: 4, duration: 250, delay: 8500 },
      { note: 'F#', octave: 4, duration: 250, delay: 8750 },
      { note: 'G', octave: 4, duration: 250, delay: 9000 },
      { note: 'A', octave: 4, duration: 250, delay: 9250 },
      { note: 'B', octave: 4, duration: 250, delay: 9500 },
      { note: 'C#', octave: 5, duration: 250, delay: 9750 },

      { note: 'D', octave: 5, duration: 250, delay: 10000 },
      { note: 'B', octave: 4, duration: 250, delay: 10250 },
      { note: 'C#', octave: 5, duration: 250, delay: 10500 },
      { note: 'D', octave: 5, duration: 250, delay: 10750 },
      { note: 'C#', octave: 5, duration: 250, delay: 11000 },
      { note: 'B', octave: 4, duration: 250, delay: 11250 },
      { note: 'A', octave: 4, duration: 250, delay: 11500 },
      { note: 'G', octave: 4, duration: 250, delay: 11750 },

      { note: 'F#', octave: 4, duration: 250, delay: 12000 },
      { note: 'G', octave: 4, duration: 250, delay: 12250 },
      { note: 'A', octave: 4, duration: 250, delay: 12500 },
      { note: 'B', octave: 4, duration: 250, delay: 12750 },
      { note: 'A', octave: 4, duration: 250, delay: 13000 },
      { note: 'G', octave: 4, duration: 250, delay: 13250 },
      { note: 'F#', octave: 4, duration: 250, delay: 13500 },
      { note: 'E', octave: 4, duration: 250, delay: 13750 },

      { note: 'D', octave: 4, duration: 250, delay: 14000 },
      { note: 'E', octave: 4, duration: 250, delay: 14250 },
      { note: 'F#', octave: 4, duration: 250, delay: 14500 },
      { note: 'G', octave: 4, duration: 250, delay: 14750 },
      { note: 'F#', octave: 4, duration: 250, delay: 15000 },
      { note: 'E', octave: 4, duration: 250, delay: 15250 },
      { note: 'D', octave: 4, duration: 250, delay: 15500 },
      { note: 'C#', octave: 4, duration: 250, delay: 15750 },

      // Variation 2
      { note: 'B', octave: 4, duration: 250, delay: 16000 },
      { note: 'C#', octave: 5, duration: 250, delay: 16250 },
      { note: 'D', octave: 5, duration: 500, delay: 16500 },
      { note: 'B', octave: 4, duration: 250, delay: 17000 },
      { note: 'C#', octave: 5, duration: 250, delay: 17250 },
      { note: 'D', octave: 5, duration: 500, delay: 17500 },

      { note: 'B', octave: 4, duration: 250, delay: 18000 },
      { note: 'C#', octave: 5, duration: 250, delay: 18250 },
      { note: 'D', octave: 5, duration: 250, delay: 18500 },
      { note: 'E', octave: 5, duration: 250, delay: 18750 },
      { note: 'F#', octave: 5, duration: 250, delay: 19000 },
      { note: 'E', octave: 5, duration: 250, delay: 19250 },
      { note: 'D', octave: 5, duration: 250, delay: 19500 },
      { note: 'C#', octave: 5, duration: 250, delay: 19750 },

      // Final section
      { note: 'B', octave: 4, duration: 500, delay: 20000 },
      { note: 'A', octave: 4, duration: 500, delay: 20500 },
      { note: 'G', octave: 4, duration: 500, delay: 21000 },
      { note: 'F#', octave: 4, duration: 500, delay: 21500 },
      { note: 'E', octave: 4, duration: 500, delay: 22000 },
      { note: 'F#', octave: 4, duration: 500, delay: 22500 },
      { note: 'G', octave: 4, duration: 500, delay: 23000 },
      { note: 'A', octave: 4, duration: 500, delay: 23500 },

      { note: 'B', octave: 4, duration: 500, delay: 24000 },
      { note: 'C#', octave: 5, duration: 500, delay: 24500 },
      { note: 'D', octave: 5, duration: 1000, delay: 25000 },
      { note: 'C#', octave: 5, duration: 500, delay: 26000 },
      { note: 'B', octave: 4, duration: 500, delay: 26500 },
      { note: 'A', octave: 4, duration: 1000, delay: 27000 },
      { note: 'D', octave: 5, duration: 1500, delay: 28000 },
    ],
  },

  // Amazing Grace (Public Domain)
  amazingGrace: {
    title: 'アメイジング・グレイス',
    titleEn: 'Amazing Grace',
    recommendedDrum: 'バラード',
    recommendedDrumKey: 'ballad',
    bpm: 75,
    tempo: 75,
    notes: [
      // Verse 1
      { note: 'G', octave: 4, duration: 400, delay: 0 },
      { note: 'C', octave: 5, duration: 800, delay: 400 },
      { note: 'E', octave: 5, duration: 200, delay: 1200 },
      { note: 'C', octave: 5, duration: 600, delay: 1400 },
      { note: 'E', octave: 5, duration: 800, delay: 2000 },
      { note: 'D', octave: 5, duration: 800, delay: 2800 },
      { note: 'C', octave: 5, duration: 800, delay: 3600 },
      { note: 'A', octave: 4, duration: 800, delay: 4400 },
      { note: 'G', octave: 4, duration: 800, delay: 5200 },

      { note: 'G', octave: 4, duration: 400, delay: 6000 },
      { note: 'C', octave: 5, duration: 800, delay: 6400 },
      { note: 'E', octave: 5, duration: 200, delay: 7200 },
      { note: 'C', octave: 5, duration: 600, delay: 7400 },
      { note: 'E', octave: 5, duration: 800, delay: 8000 },
      { note: 'D', octave: 5, duration: 800, delay: 8800 },
      { note: 'G', octave: 5, duration: 1600, delay: 9600 },

      { note: 'E', octave: 5, duration: 400, delay: 11200 },
      { note: 'G', octave: 5, duration: 800, delay: 11600 },
      { note: 'G', octave: 5, duration: 200, delay: 12400 },
      { note: 'E', octave: 5, duration: 600, delay: 12600 },
      { note: 'C', octave: 5, duration: 800, delay: 13200 },
      { note: 'D', octave: 5, duration: 800, delay: 14000 },
      { note: 'E', octave: 5, duration: 800, delay: 14800 },
      { note: 'D', octave: 5, duration: 800, delay: 15600 },
      { note: 'C', octave: 5, duration: 800, delay: 16400 },
      { note: 'A', octave: 4, duration: 800, delay: 17200 },

      { note: 'G', octave: 4, duration: 400, delay: 18000 },
      { note: 'C', octave: 5, duration: 800, delay: 18400 },
      { note: 'E', octave: 5, duration: 200, delay: 19200 },
      { note: 'C', octave: 5, duration: 600, delay: 19400 },
      { note: 'E', octave: 5, duration: 800, delay: 20000 },
      { note: 'D', octave: 5, duration: 800, delay: 20800 },
      { note: 'C', octave: 5, duration: 1600, delay: 21600 },

      // Verse 2 (variation)
      { note: 'C', octave: 5, duration: 400, delay: 23200 },
      { note: 'E', octave: 5, duration: 400, delay: 23600 },
      { note: 'G', octave: 5, duration: 400, delay: 24000 },
      { note: 'E', octave: 5, duration: 400, delay: 24400 },
      { note: 'C', octave: 5, duration: 400, delay: 24800 },
      { note: 'G', octave: 4, duration: 400, delay: 25200 },
      { note: 'E', octave: 4, duration: 400, delay: 25600 },
      { note: 'G', octave: 4, duration: 400, delay: 26000 },

      { note: 'A', octave: 4, duration: 400, delay: 26400 },
      { note: 'C', octave: 5, duration: 400, delay: 26800 },
      { note: 'E', octave: 5, duration: 400, delay: 27200 },
      { note: 'D', octave: 5, duration: 400, delay: 27600 },
      { note: 'C', octave: 5, duration: 400, delay: 28000 },
      { note: 'D', octave: 5, duration: 400, delay: 28400 },
      { note: 'E', octave: 5, duration: 400, delay: 28800 },
      { note: 'G', octave: 5, duration: 400, delay: 29200 },

      { note: 'E', octave: 5, duration: 800, delay: 29600 },
      { note: 'D', octave: 5, duration: 800, delay: 30400 },
      { note: 'C', octave: 5, duration: 800, delay: 31200 },
      { note: 'D', octave: 5, duration: 800, delay: 32000 },
      { note: 'E', octave: 5, duration: 800, delay: 32800 },
      { note: 'D', octave: 5, duration: 800, delay: 33600 },
      { note: 'C', octave: 5, duration: 2000, delay: 34400 },
    ],
  },

  // Für Elise (Beethoven - Public Domain)
  furElise: {
    title: 'エリーゼのために',
    titleEn: 'Für Elise',
    recommendedDrum: 'メトロノーム',
    recommendedDrumKey: 'metronome',
    bpm: 120,
    tempo: 120,
    notes: [
      // Main theme
      { note: 'E', octave: 5, duration: 150, delay: 0 },
      { note: 'D#', octave: 5, duration: 150, delay: 150 },
      { note: 'E', octave: 5, duration: 150, delay: 300 },
      { note: 'D#', octave: 5, duration: 150, delay: 450 },
      { note: 'E', octave: 5, duration: 150, delay: 600 },
      { note: 'B', octave: 4, duration: 150, delay: 750 },
      { note: 'D', octave: 5, duration: 150, delay: 900 },
      { note: 'C', octave: 5, duration: 150, delay: 1050 },
      { note: 'A', octave: 4, duration: 450, delay: 1200 },

      { note: 'C', octave: 4, duration: 150, delay: 1650 },
      { note: 'E', octave: 4, duration: 150, delay: 1800 },
      { note: 'A', octave: 4, duration: 150, delay: 1950 },
      { note: 'B', octave: 4, duration: 450, delay: 2100 },

      { note: 'E', octave: 4, duration: 150, delay: 2550 },
      { note: 'G#', octave: 4, duration: 150, delay: 2700 },
      { note: 'B', octave: 4, duration: 150, delay: 2850 },
      { note: 'C', octave: 5, duration: 450, delay: 3000 },

      { note: 'E', octave: 4, duration: 150, delay: 3450 },
      { note: 'E', octave: 5, duration: 150, delay: 3600 },
      { note: 'D#', octave: 5, duration: 150, delay: 3750 },
      { note: 'E', octave: 5, duration: 150, delay: 3900 },
      { note: 'D#', octave: 5, duration: 150, delay: 4050 },
      { note: 'E', octave: 5, duration: 150, delay: 4200 },
      { note: 'B', octave: 4, duration: 150, delay: 4350 },
      { note: 'D', octave: 5, duration: 150, delay: 4500 },
      { note: 'C', octave: 5, duration: 150, delay: 4650 },
      { note: 'A', octave: 4, duration: 450, delay: 4800 },

      { note: 'C', octave: 4, duration: 150, delay: 5250 },
      { note: 'E', octave: 4, duration: 150, delay: 5400 },
      { note: 'A', octave: 4, duration: 150, delay: 5550 },
      { note: 'B', octave: 4, duration: 450, delay: 5700 },

      { note: 'E', octave: 4, duration: 150, delay: 6150 },
      { note: 'C', octave: 5, duration: 150, delay: 6300 },
      { note: 'B', octave: 4, duration: 150, delay: 6450 },
      { note: 'A', octave: 4, duration: 450, delay: 6600 },

      // Second section
      { note: 'B', octave: 4, duration: 150, delay: 7050 },
      { note: 'C', octave: 5, duration: 150, delay: 7200 },
      { note: 'D', octave: 5, duration: 150, delay: 7350 },
      { note: 'E', octave: 5, duration: 450, delay: 7500 },

      { note: 'G', octave: 4, duration: 150, delay: 7950 },
      { note: 'F', octave: 5, duration: 150, delay: 8100 },
      { note: 'E', octave: 5, duration: 150, delay: 8250 },
      { note: 'D', octave: 5, duration: 450, delay: 8400 },

      { note: 'F', octave: 4, duration: 150, delay: 8850 },
      { note: 'E', octave: 5, duration: 150, delay: 9000 },
      { note: 'D', octave: 5, duration: 150, delay: 9150 },
      { note: 'C', octave: 5, duration: 450, delay: 9300 },

      { note: 'E', octave: 4, duration: 150, delay: 9750 },
      { note: 'D', octave: 5, duration: 150, delay: 9900 },
      { note: 'C', octave: 5, duration: 150, delay: 10050 },
      { note: 'B', octave: 4, duration: 450, delay: 10200 },

      // Repeat main theme
      { note: 'E', octave: 5, duration: 150, delay: 10650 },
      { note: 'D#', octave: 5, duration: 150, delay: 10800 },
      { note: 'E', octave: 5, duration: 150, delay: 10950 },
      { note: 'D#', octave: 5, duration: 150, delay: 11100 },
      { note: 'E', octave: 5, duration: 150, delay: 11250 },
      { note: 'B', octave: 4, duration: 150, delay: 11400 },
      { note: 'D', octave: 5, duration: 150, delay: 11550 },
      { note: 'C', octave: 5, duration: 150, delay: 11700 },
      { note: 'A', octave: 4, duration: 600, delay: 11850 },
    ],
  },

  // Mary Had a Little Lamb (Public Domain) - Simple version for beginners
  maryHadALittleLamb: {
    title: 'メリーさんの羊',
    titleEn: 'Mary Had a Little Lamb',
    recommendedDrum: 'ポップ',
    recommendedDrumKey: 'pop',
    bpm: 100,
    tempo: 100,
    notes: [
      { note: 'E', octave: 4, duration: 300, delay: 0 },
      { note: 'D', octave: 4, duration: 300, delay: 300 },
      { note: 'C', octave: 4, duration: 300, delay: 600 },
      { note: 'D', octave: 4, duration: 300, delay: 900 },
      { note: 'E', octave: 4, duration: 300, delay: 1200 },
      { note: 'E', octave: 4, duration: 300, delay: 1500 },
      { note: 'E', octave: 4, duration: 600, delay: 1800 },
      { note: 'D', octave: 4, duration: 300, delay: 2400 },
      { note: 'D', octave: 4, duration: 300, delay: 2700 },
      { note: 'D', octave: 4, duration: 600, delay: 3000 },
      { note: 'E', octave: 4, duration: 300, delay: 3600 },
      { note: 'G', octave: 4, duration: 300, delay: 3900 },
      { note: 'G', octave: 4, duration: 600, delay: 4200 },
      { note: 'E', octave: 4, duration: 300, delay: 4800 },
      { note: 'D', octave: 4, duration: 300, delay: 5100 },
      { note: 'C', octave: 4, duration: 300, delay: 5400 },
      { note: 'D', octave: 4, duration: 300, delay: 5700 },
      { note: 'E', octave: 4, duration: 300, delay: 6000 },
      { note: 'E', octave: 4, duration: 300, delay: 6300 },
      { note: 'E', octave: 4, duration: 300, delay: 6600 },
      { note: 'E', octave: 4, duration: 300, delay: 6900 },
      { note: 'D', octave: 4, duration: 300, delay: 7200 },
      { note: 'D', octave: 4, duration: 300, delay: 7500 },
      { note: 'E', octave: 4, duration: 300, delay: 7800 },
      { note: 'D', octave: 4, duration: 300, delay: 8100 },
      { note: 'C', octave: 4, duration: 900, delay: 8400 },
    ],
  },

  // Happy Birthday (Public Domain)
  happyBirthday: {
    title: 'ハッピーバースデー',
    titleEn: 'Happy Birthday',
    recommendedDrum: 'ポップ',
    recommendedDrumKey: 'pop',
    bpm: 100,
    tempo: 100,
    notes: [
      { note: 'C', octave: 4, duration: 200, delay: 0 },
      { note: 'C', octave: 4, duration: 200, delay: 200 },
      { note: 'D', octave: 4, duration: 400, delay: 400 },
      { note: 'C', octave: 4, duration: 400, delay: 800 },
      { note: 'F', octave: 4, duration: 400, delay: 1200 },
      { note: 'E', octave: 4, duration: 800, delay: 1600 },
      { note: 'C', octave: 4, duration: 200, delay: 2400 },
      { note: 'C', octave: 4, duration: 200, delay: 2600 },
      { note: 'D', octave: 4, duration: 400, delay: 2800 },
      { note: 'C', octave: 4, duration: 400, delay: 3200 },
      { note: 'G', octave: 4, duration: 400, delay: 3600 },
      { note: 'F', octave: 4, duration: 800, delay: 4000 },
      { note: 'C', octave: 4, duration: 200, delay: 4800 },
      { note: 'C', octave: 4, duration: 200, delay: 5000 },
      { note: 'C', octave: 5, duration: 400, delay: 5200 },
      { note: 'A', octave: 4, duration: 400, delay: 5600 },
      { note: 'F', octave: 4, duration: 400, delay: 6000 },
      { note: 'E', octave: 4, duration: 400, delay: 6400 },
      { note: 'D', octave: 4, duration: 800, delay: 6800 },
      { note: 'A#', octave: 4, duration: 200, delay: 7600 },
      { note: 'A#', octave: 4, duration: 200, delay: 7800 },
      { note: 'A', octave: 4, duration: 400, delay: 8000 },
      { note: 'F', octave: 4, duration: 400, delay: 8400 },
      { note: 'G', octave: 4, duration: 400, delay: 8800 },
      { note: 'F', octave: 4, duration: 1200, delay: 9200 },
    ],
  },
};